export default "__VITE_ASSET__DRFt97BD__"